// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasicView-view-8005{width:100%;height:var(--page-viewport-height-simple)}.BasicView-pane-8005{width:100%;height:100%;padding:64px 40px;justify-content:center}`, "",{"version":3,"sources":["webpack://./src/page/ProfileScreen/view/BasicView.module.scss"],"names":[],"mappings":"AAAA,qBACE,UAAA,CACA,yCAAA,CAGF,qBACE,UAAA,CACA,WAAA,CACA,iBAAA,CACA,sBAAA","sourcesContent":[".view {\n  width: 100%;\n  height: var(--page-viewport-height-simple);\n}\n\n.pane {\n  width: 100%;\n  height: 100%;\n  padding: 64px 40px;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `BasicView-view-8005`,
	"pane": `BasicView-pane-8005`
};
module.exports = ___CSS_LOADER_EXPORT___;
